import { trpc } from '@/shared/api';

/** 추천이 바뀌면 추천 목록과 상품 목록 표(추천 순위 칸)를 함께 무효화한다. */
export const useInvalidateRecommendedProducts = (): (() => void) => {
  const utils = trpc.useUtils();

  return () => {
    void utils.productManagement.recommendations.list.invalidate();
    void utils.productManagement.products.list.invalidate();
  };
};
